<template>
  <div style="background-color: #fff; padding: 20px; position: relative">
    <div class="title">
      {{ testData.subjectName }}第{{ testData.sequence }}期
    </div>
    <el-table :data="testData.examinationSettingItemList" border style="width: 100%">
      <el-table-column prop="courseName" label="考试名称" width="130"></el-table-column>
      <el-table-column label="考试费（RMB）" width="123">
        <template slot-scope="scope">
          <el-input style="width: 100px" type="number" size="mini" min="0" v-model="scope.row.amount"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="考试时间" width="480px">
        <template slot-scope="scope">
          <!-- <div>{{timeArr[scope.$index].examDate}}</div> -->
          <div style="display: flex">
            <!-- @change="examDateChange(timeArr[scope.$index].examDate)" minTime: addTestsignTime[1].slice(11, 16),-->
            <el-date-picker v-model="timeArr[scope.$index].examDate" size="mini" type="date" format="yyyy-MM-dd" :picker-options="examTimeSet" value-format="yyyy-MM-dd" placeholder="选择考试日期" @change="timeChange(timeArr[scope.$index], scope, 1)">
            </el-date-picker>
            <el-time-picker v-model="timeArr[scope.$index].examBegin" size="mini" format="HH:mm" value-format="HH:mm" placeholder="考试开始时间" @change="timeChange(timeArr[scope.$index], scope)">
            </el-time-picker><!-- selectableRange: `${scope.row.timeArr ? scope.row.timeArr[scope.$index].examBegin : timeArr[scope.$index].examBegin} - 20:30`, -->
            &nbsp;至&nbsp;
            <el-time-picker v-model="timeArr[scope.$index].examEnd" size="mini" format="HH:mm" value-format="HH:mm" placeholder="考试结束时间" @change="timeChange(timeArr[scope.$index], scope)">
            </el-time-picker>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="试卷">
        <template slot-scope="scope">
          <el-select style="min-width: 250px" size="mini" filterable v-model="scope.row.examId" clearable placeholder="选择试卷" @change="testPaperChange(scope)">
            <el-option v-for="item in scope.row.testPaper" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="试卷审批人">
        <template slot-scope="scope">
          <el-select :key="isTeacher" :disabled="!isTeacher" style="min-width: 300px" size="mini" filterable multiple v-model="teacherId" clearable placeholder="选择审批人" @change="teacherChange">
            <el-option v-for="item in teacher" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>

    <div class="bottom-box">
      <div class="left-box">
        <div class="test-item">
          <div class="cardTitle anchor">考试介绍</div>
          <div style="background: #fff">
            <UE :isShow="false" id="examIntroduce" ref="examIntroduceUE" :value="testData.introduction" reff="1"></UE>
          </div>
        </div>
        <div class="test-item">
          <div class="cardTitle anchor">考生须知</div>
          <div style="background: #fff">
            <UE id="infoToStu" ref="infoToStuUE" :value="testData.note" reff="2"></UE>
          </div>
        </div>
        <div class="test-item">
          <div class="cardTitle anchor">报名流程</div>
          <div style="background: #fff">
            <UE id="regProcess" ref="regProcessUE" :value="testData.flow" reff="3"></UE>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="set-item">
          <div style="margin-bottom: 5px">报名时间设置</div>
          <div>
            <!-- <el-button type="primary" size="small" @click="changeTime1 = !changeTime1">修改</el-button> -->
            <!-- <span v-if="changeTime1">{{
              addTestsignTime[0].slice(0, 16) + " 至 " + addTestsignTime[1].slice(0, 16)
            }}</span> -->
            <el-date-picker size="small" v-model="addTestsignTime" @blur="numChange(addTestsignTime)" :picker-options="testsignStartDate" type="datetimerange" range-separator="至" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
        <div class="set-item">
          <div style="margin-bottom: 5px">成绩查询时间</div>
          <div>
            <!-- <el-button type="primary" size="small" @click="changeTime2 = !changeTime2">修改</el-button> -->
            <!-- <span v-if="changeTime2">{{ testData.showTime ? testData.showTime.slice(0, 16) : '' }}</span> -->
            <el-date-picker size="small" v-model="testData.showTime" :key="num" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="成绩查询时间" :picker-options="showTimeSet">
            </el-date-picker>
          </div>
        </div>

        <div class="set-item">
          <div>
            报名信息信息设置
            <el-button type="text">已选{{ infoChecked.length }}</el-button>
          </div>

          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group class="check-box" v-model="infoChecked" @change="handleCheckedCitiesChange">
            <el-checkbox class="check-item" :disabled="
                item.code == 'name' ||
                item.code == 'mobile' ||
                item.code == 'sex' ||
                item.code == 'cardType' ||
                item.code == 'card' ||
                item.code == 'cardFrontPicId' ||
                item.code == 'cardBackPicId' ||
                item.code == 'threeMonthPicId'
              " v-for="item in infoList" :label="item.id" :key="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="footer-box">
          <el-button @click="$router.go(-1)">取消</el-button>
          <el-button type="primary" @click="submit">提交</el-button>
        </div>
      </div>
    </div>
    <!-- v-if="examState == 1" -->
  </div>
</template>
<script>
let signEndTime = ""; // 报名结束时间
let examEndTime = ""; // 考试结束时间
import UE from "../conmom/CKEditorMultiply.vue";
export default {
  components: { UE },
  computed: {
    isDisabled () {
      this.infoList.forEach((item) => {
        if (
          item.code == "name" ||
          item.code == "mobile" ||
          item.code == "sex" ||
          item.code == "cardType" ||
          item.code == "card" ||
          item.code == "cardFrontPicId" ||
          item.code == "cardBackPicId" ||
          item.code == "threeMonthPicId"
        ) {
          if (this.infoChecked.indexOf(item.id) == -1) {
            return false;
          }
        }
      });
    },
  },
  data () {
    return {
      timeArr: [],
      isTeacher: false,
      examState: 0,
      examTimeSet: {
        disabledDate (time) {
          let timer = new Date(signEndTime) - 24 * 60 * 60 * 1000;
          return time.getTime() < timer;
        },
      },
      showTimeSet: {
        disabledDate (time) {
          return time.getTime() < examEndTime - 24 * 60 * 60 * 1000;
        },
      },
      testsignStartDate: {
        // 报名时间限制
        disabledDate (time) {
          let _now = Date.now() - 24 * 60 * 60 * 1000;
          return time.getTime() < _now;
        },
      },
      changeTime1: true,
      changeTime2: true,
      num: 0,
      id: "",
      testData: null,
      teacher: [],
      testPaper: [],
      examIntroduce: "",
      infoToStu: "",
      regProcess: "",
      isIndeterminate: true,
      infoList: [],
      infoChecked: [],
      checkAll: false,
      addTestsignTime: [],
      testPaperId: "",
      teacherId: [],
    };
  },
  created () {
    this.id = this.$route.query.id;
    this.examState = this.$route.query.examState;
  },
  mounted () {
    this.getTest();
  },
  //   flow: 流程   note：考生须知  introduction 考试介绍
  //   1 需要设置
  //    判断是否需要有试卷审批人  在请求数据的时候判断    在每次 选择试卷的时候 都判断一下
  methods: {
    timeChange (val, scope, n) {
      scope.row.examTimeArr[0] = val.examDate + " " + val.examBegin + ":00";
      scope.row.examTimeArr[1] = val.examDate + " " + val.examEnd + ":00";

      // 此处有bug
      if (n) {
        // 试卷考试日期改变 判断外层考试时间是否需要改变  放在提交的时候
        let oldTime = new Date(this.testData.examEndTime);
        let time = new Date(scope.row.examTimeArr[1]);
        if (time > oldTime) {
          this.testData.examEndTime = scope.row.examTimeArr[1];
        }
      }
      // 更新查询日期选择范围
      let newEnd = new Date(scope.row.examTimeArr[1]);
      newEnd > examEndTime ? (examEndTime = newEnd) : null;
      this.num += 1;
    },

    numChange (val) {
      signEndTime = val[1];
      this.num += 1;
    },
    change (val) {
      // 强制更新 日期时间选择器视图
      this.num += 1;
      let timer = new Date(val[1]);
      examEndTime = timer;
      // timer.getTime() > examEndTime.getTime() ? (examEndTime = timer) : null;
    },
    examDateChange (val) {
      this.num += 1;
      let oldTime = new Date(this.testData.examEndTime);
      let time = new Date(val);
      if (time > oldTime) {
        this.testData.examEndTime = val;
      }
    },
    getTest () {
      this.api.signInLog
        .getExaminationSettingDetail({ id: this.id })
        .then((res) => {
          if (res.code == 200) {
            this.testData = res.data;
            // 长度判断
            if (this.testData.showTime) {
              this.testData.showTime.length < 11
                ? (this.testData.showTime =
                  this.testData.showTime + " 00:00:00")
                : null;
              this.testData.signBeginTime.length < 11
                ? (this.testData.signBeginTime =
                  this.testData.signBeginTime + " 00:00:00")
                : null;
              this.testData.signEndTime.length < 11
                ? (this.testData.signEndTime =
                  this.testData.signEndTime + " 00:00:00")
                : null;
            }

            this.addTestsignTime = [];
            if (this.testData.signBeginTime) {
              signEndTime = this.testData.signEndTime;
              this.addTestsignTime.push(
                this.testData.signBeginTime,
                this.testData.signEndTime
              );
            }
            // console.log(1111111111111, this.addTestsignTime);

            this.infoChecked = [];
            if (this.testData.fieldRelationList) {
              this.testData.fieldRelationList.forEach((item) => {
                this.infoChecked.push(item.fieldId);
              });
            }

            this.teacherId = [];
            if (this.testData.examinationTeacherRelationList) {
              //   this.isTeacher = true;
              this.testData.examinationTeacherRelationList.forEach((item) => {
                this.teacherId.push(item.teacherId);
              });
            } else this.isTeacher = false;
            // console.log(this.isTeacher);

            // 获取试卷
            if (this.testData.examinationSettingItemList) {
              this.testData.examinationSettingItemList.forEach((item) => {
                item.isTeacher = false;
                item.examTimeArr = [];
                // 考试时间
                if (item.examBeginTime) {
                  // console.log(111111111);
                  let timer = new Date(item.examEndTime);
                  // 判断哪一个试卷考试开始时间大
                  if (examEndTime) {
                    timer.getTime() > examEndTime.getTime()
                      ? (examEndTime = timer)
                      : null;
                  } else examEndTime = timer;
                  let obj = {
                    examDate: item.examBeginTime.slice(0, 10),
                    examBegin: item.examBeginTime.slice(11, 16),
                    examEnd: item.examEndTime.slice(11, 16),
                  };
                  this.timeArr.push(obj);
                  item.examTimeArr.push(item.examBeginTime, item.examEndTime);
                } else {
                  // console.log(222222222222);
                  examEndTime = new Date();
                  let obj2 = {
                    examDate: "",
                    examBegin: "",
                    examEnd: "",
                  };
                  this.timeArr.push(obj2);
                }
                // console.log(item);
                // console.log(item.examTimeArr);

                // 获取该项目考试试卷
                this.api.signInLog
                  .getExamList({ courseId: item.courseId, type: "考试系统" })
                  .then((res) => {
                    if (res.code == 200) item.testPaper = res.data;
                  });

                // 判断该试卷 有没有主观题
                this.validExaminationTeacherByExamId(item.examId);
                // 获取审批人
                this.api.signInLog.getAgentTeacherList().then((res) => {
                  if (res.code == 200) this.teacher = res.data;
                });
              });
              // console.log(this.timeArr);
              //   获取报名信息设置
              this.api.signInLog
                .getFieldList({
                  typeId: this.id,
                })
                .then((res) => {
                  // console.log(res.data);
                  if (res.code == 200) {
                    this.infoList = res.data;
                    this.infoList.forEach((item) => {
                      if (
                        item.code == "name" ||
                        item.code == "mobile" ||
                        item.code == "sex" ||
                        item.code == "cardType" ||
                        item.code == "card" ||
                        item.code == "cardFrontPicId" ||
                        item.code == "cardBackPicId" ||
                        item.code == "threeMonthPicId"
                      ) {
                        if (this.infoChecked.indexOf(item.id) == -1) {
                          this.infoChecked.push(item.id);
                        }
                      }
                    });
                  }
                });
            }
          }
        });
    },
    submit () {
      // console.log(this.addTestsignTime);
      // if (this.addTestsignTime[0].length == 16) {
      //   this.testData.signBeginTime = this.addTestsignTime[0] + ':00';
      //   this.testData.signEndTime = this.addTestsignTime[1] + ':00';
      // } else {
      //   this.testData.signBeginTime = this.addTestsignTime[0];
      //   this.testData.signEndTime = this.addTestsignTime[1];
      // }
      // console.log(this.testData);
      let isSubmit = true;
      let examBeginNow = this.testData.examinationSettingItemList[0]
        .examBeginTime,
        examEndNow = this.testData.examinationSettingItemList[0].examEndTime;
      let item = null;
      for (let index = 0; index < this.testData.examinationSettingItemList.length; index++) {
        item = this.testData.examinationSettingItemList[index];
        item.examEndTime = item.examTimeArr[1];
        item.examBeginTime = item.examTimeArr[0];
        // item.examEndTime = item.examTimeArr[1] + ' 00:00:00';
        // item.examBeginTime = item.examTimeArr[0] + ' 00:00:00';
        if (
          item.amount != 0 &&
          item.examBeginTime != null &&
          item.examId != null
        ) {
          console.log(item);
          if (!item.amount && isSubmit)
            this.$message.error("请输入考试费"), (isSubmit = false);
          if ((!item.examBeginTime || !item.examEndTime) && isSubmit)
            this.$message.error("请输入考试时间"), (isSubmit = false);
          if (!item.examId && isSubmit)
            this.$message.error("请选择试卷"), (isSubmit = false);

          // 判断最小开始时间 和 最大结束时间
          if (
            new Date(
              this.testData.examinationSettingItemList[index].examBeginTime
            ) < new Date(examBeginNow)
          ) {
            examBeginNow = this.testData.examinationSettingItemList[index]
              .examBeginTime;
          }
          if (
            new Date(
              this.testData.examinationSettingItemList[index].examEndTime
            ) > new Date(examEndNow)
          ) {
            examEndNow = this.testData.examinationSettingItemList[index]
              .examEndTime;
          }
        }
      }
      // this.testData.examinationSettingItemList.forEach((item, index) => {
      //   item.examEndTime = item.examTimeArr[1];
      //   item.examBeginTime = item.examTimeArr[0];
      //   // item.examEndTime = item.examTimeArr[1] + ' 00:00:00';
      //   // item.examBeginTime = item.examTimeArr[0] + ' 00:00:00';
      //   if (
      //     item.amount != 0 &&
      //     item.examBeginTime != null &&
      //     item.examId != null
      //   ) {
      //     console.log(item);
      //     if (!item.amount && isSubmit)
      //       this.$message.error("请输入考试费"), (isSubmit = false);
      //     if ((!item.examBeginTime || !item.examEndTime) && isSubmit)
      //       this.$message.error("请输入考试时间"), (isSubmit = false);
      //     if (!item.examId && isSubmit)
      //       this.$message.error("请选择试卷"), (isSubmit = false);

      //     // 判断最小开始时间 和 最大结束时间
      //     if (
      //       new Date(
      //         this.testData.examinationSettingItemList[index].examBeginTime
      //       ) < new Date(examBeginNow)
      //     ) {
      //       examBeginNow = this.testData.examinationSettingItemList[index]
      //         .examBeginTime;
      //     }
      //     if (
      //       new Date(
      //         this.testData.examinationSettingItemList[index].examEndTime
      //       ) > new Date(examEndNow)
      //     ) {
      //       examEndNow = this.testData.examinationSettingItemList[index]
      //         .examEndTime;
      //     }
      //   }
      //   // console.log(this.testData.examinationSettingItemList[index].examBeginTime, this.testData.examinationSettingItemList[index].examEndTime);
      // });
      // console.log(examBeginNow, examEndNow);
      this.testData.examBeginTime = examBeginNow;
      this.testData.examEndTime = examEndNow;

      if (this.addTestsignTime[0].length == 16) {
        this.testData.signBeginTime = this.addTestsignTime[0] + ":00";
        this.testData.signEndTime = this.addTestsignTime[1] + ":00";
      } else {
        this.testData.signBeginTime = this.addTestsignTime[0];
        this.testData.signEndTime = this.addTestsignTime[1];
      }

      this.testData.fieldRelationList = [];
      this.infoChecked.forEach((item) => {
        let obj = {};
        obj.fieldId = item;
        this.testData.fieldRelationList.push(obj);
      });

      this.testData.examinationTeacherRelationList = [];
      this.teacherId.forEach((item) => {
        let obj = {};
        obj.teacherId = item;
        this.testData.examinationTeacherRelationList.push(obj);
      });

      this.testData.introduction = this.$refs.examIntroduceUE._data.content;
      this.testData.note = this.$refs.infoToStuUE._data.content;
      this.testData.flow = this.$refs.regProcessUE._data.content;

      //   console.log(this.testData);
      if (!this.testData.flow && isSubmit)
        this.$message.error("请输入报名流程"), (isSubmit = false);
      if (this.testData.fieldRelationList.length == 0 && isSubmit)
        this.$message.error("请选择报名信息信息设置"), (isSubmit = false);
      if (
        (!this.testData.signBeginTime || !this.testData.signEndTime) &&
        isSubmit
      )
        this.$message.error("请输入报名时间"), (isSubmit = false);
      if (!this.testData.introduction && isSubmit)
        this.$message.error("请输入考试介绍"), (isSubmit = false);
      if (!this.testData.note && isSubmit)
        this.$message.error("请输入考生须知"), (isSubmit = false);
      if (!this.testData.showTime && isSubmit)
        this.$message.error("请输入成绩查询时间"), (isSubmit = false);

      if (
        this.isTeacher &&
        this.testData.examinationTeacherRelationList.length == 0
      )
        this.$message.error("请选择审批人");

      if (this.testData.showTime.length == 16) {
        this.testData.showTime = this.testData.showTime + ":00";
      }
      console.log(this.testData);
      if (isSubmit) {
        setTimeout(() => {
          this.api.signInLog
            .updateExaminationSetting(this.testData)
            .then((res) => {
              if (res.code == 200) {
                this.getTest();
                this.$message.success(res.message);
                this.$router.go(-1);
              } else this.$message.error(res.message);
            });
        })

      }
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.infoList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.infoList.length;
    },
    handleCheckAllChange (val) {
      if (val) {
        this.infoList.forEach((item) => {
          if (this.infoChecked.indexOf(item.id) == -1) {
            this.infoChecked.push(item.id);
          }
        });
      } else {
        this.infoChecked = [];
        this.infoList.forEach((item) => {
          if (
            item.code == "name" ||
            item.code == "mobile" ||
            item.code == "sex" ||
            item.code == "cardType" ||
            item.code == "card" ||
            item.code == "cardFrontPicId" ||
            item.code == "cardBackPicId" ||
            item.code == "threeMonthPicId"
          ) {
            if (this.infoChecked.indexOf(item.id) == -1) {
              this.infoChecked.push(item.id);
            }
          }
        });
      }
      this.isIndeterminate = false;
    },
    testPaperChange (val) {
      // 判断是否需要审批人
      this.isTeacher = false;
      this.testData.examinationSettingItemList.forEach((item) => {
        this.validExaminationTeacherByExamId(item.examId);
      });
    },
    validExaminationTeacherByExamId (examId) {
      this.api.signInLog
        .validExaminationTeacherByExamId({
          examId,
        })
        .then((res) => {
          if (res.code == 200 && res.data.isShow == 1) this.isTeacher = true;
        });
    },
    teacherChange (val) {
      console.log(val);
    },
  },
};
</script>
<style scoped>
.footer-box {
  background-color: #fff;
  margin-top: 50px;
}
.title {
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
  font-weight: 700;
  font-size: 16px;
  color: #455a64;
  margin-bottom: 20px;
}
.bottom-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* margin-bottom: 60px; */
}
.left-box,
.right-box {
  width: 47%;
}
.set-item,
.test-item {
  margin-top: 20px;
}
.check-box {
  width: 300px;
  height: 180px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.check-item {
  width: 130px;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/fullTruthModelTest/examSettingDetail.vue